import { ApiService } from 'src/common/api-service/API-BETTING'

export default {
  namespace: true,
  state: () => ({
    sportsList: [],
    resultsSport: [],
    currentSport: '',
    currentDate: '',
    isLoading: false,
    filteredSportsIds: [],
  }),
  mutations: {
    setFilteredSportsIds(state, payload) {
      state.filteredSportsIds = payload
    },
    setResultsSport(state, payload) {
      state.resultsSport = payload
    },
    setSportsList(state, payload) {
      state.sportsList = payload
    },
    setCurrentSport(state, payload) {
      state.currentSport = payload
    },
    setCurrentDate(state, payload) {
      state.currentDate = payload
    },
    setIsLoading(state, payload) {
      state.isLoading = payload
    },
  },
  actions: {
    async loadSportsList({ commit, getters }) {
      try {
        commit('setIsLoading', true)
        const { data } = await ApiService.resultsSportsList({ date: getters.dateString })
        commit('setSportsList', data)
      } catch (err) {
        console.error(err)
      } finally {
        commit('setIsLoading', false)
      }
    },
    async loadResultsSport({ commit, getters }, payload) {
      try {
        commit('setCurrentSport', '')
        commit('setIsLoading', true)
        const { data } = await ApiService.results({ date: getters.dateString, id: payload })
        commit('setResultsSport', data)
        commit('setCurrentSport', data[0].h.split('.')[0])
      } catch (err) {
        console.error(err)
      } finally {
        commit('setIsLoading', false)
      }
    },
  },
  getters: {
    getFilteredSportsIds(state) {
      return state.filteredSportsIds
    },
    getSportsList(state) {
      return state.sportsList
    },
    getResultsSport(state) {
      return state.resultsSport
    },
    getIsLoading(state) {
      return state.isLoading
    },
    getCurrentDate(state) {
      return state.currentDate
    },
    getCurrentSport(state) {
      return state.currentSport
    },
    dateString(state) {
      return new Date(state.currentDate).toISOString().split('T')[0]
    },
  },
}
